<template>
    <div class="mt-5">

        <div class="columns is-gapless message-block">
            <div class="column is-narrow message-icon"><i class="fad fa-fw fa-2x mr-2" :class="data.icon.icon" :style="{color: data.icon.color}"></i></div>
            <div class="column">
                <editor-js
                    :data="data.text.content"
                    @save="(d) => save(0, d)"
                />
            </div>
        </div>

        <div class="pt-0 pl-5 pr-4 mb-6">
            <hr />
            <div class="columns pl-2 ">
                <div class="column">
                    <b-field label="Icon" label-position="inside" grouped>
                        <b-select v-model="data.icon.icon">
                            <option value="fa-bullseye-pointer">Objective</option>
                            <option value="fa-note-sticky">Note</option>
                            <option value="fa-clipboard">Clipboard</option>
                            <option value="fa-paperclip">Paperclip</option>
                            <option value="fa-circle-check">Check</option>
                            <option value="fa-circle-info">Info</option>
                            <option value="fa-circle-question">Question</option>
                            <option value="fa-circle-pause">Pause</option>
                            <option value="fa-octagon-exclamation">Stop</option>
                            <option value="fa-thumbs-up">Thumbs Up</option>
                            <option value="fa-comments">Conversation</option>
                            <option value="fa-hand-back-point-ribbon">Remember</option>
                            <option value="fa-bell">Reminder</option>
                            <option value="fa-arrow-right">Arrow</option>
                            <option value="fa-gear">Gear</option>
                            <option value="fa-triangle-exclamation">Alert</option>
                        </b-select>
                    </b-field>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import EditorJs from "../EditorJs.vue";

    export default {
        components: {EditorJs},
        props: ['data'],
        data: function () {
            return {
                mediaPicker: false,
            };
        },
        methods: {
            save(column, data) {
                this.data.text.content = data;
            },
        },
        created() {
            if (!this.data.text) {
                this.$set(this.data, 'text', {content: null, attributes: {}});
                this.$set(this.data, 'icon', {icon: 'fa-bullseye-pointer', color: '#4a4a4a'});
            }
        }
    };
</script>

<style scoped lang="scss">

    .message-block {
        background-color: #f4f4f4;
        padding: 2rem;
        margin: 0 2rem 2rem;
        border-radius: 1rem;

        .message-icon {
            font-size: 1rem;

        }
    }
</style>
